import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3, LL_V_L, Button } from '@nu-art/thunderstorm-frontend/index';
import { Component_ManagerSubHeader, ModuleFE_Resource, QPageMessage } from '@app/hcs-frontend';
import { BadImplementationException } from '@nu-art/ts-common';
import { ResourceItem_EditorRenderer } from './Editor-renderers/ResourceItem_EditorRenderer.js';
export class EditorWrapper_Resources extends ComponentSync {
    __onSearchResultSelected = (selectedResultId, entityType) => {
        if (entityType !== ModuleFE_Resource.dbDef.dbKey)
            return;
        if (selectedResultId === this.state.item?.item._id)
            return;
        const selectedResult = ModuleFE_Resource.cache.unique(selectedResultId);
        if (!selectedResult)
            throw new BadImplementationException(`Could not find resource for id ${selectedResultId}`);
        this.reDeriveState({ item: this.createNewEditable(selectedResult) });
    };
    deriveStateFromProps(nextProps, state) {
        state.item = nextProps.item ? this.createNewEditable(nextProps.item.item) : state.item;
        state.isInEditMode = state.item && !state.item.item._id;
        return state;
    }
    createNewEditable(item) {
        return new EditableDBItemV3(item, ModuleFE_Resource, undefined)
            .setOnChanged(async (item) => {
            try {
                await item.save();
            }
            catch (err) {
                this.logError(err);
            }
        });
    }
    render() {
        if (!this.state.item)
            return _jsx(QPageMessage, { message: 'Resource Manager' });
        return this.state.item && _jsxs(LL_V_L, { className: 'match_parent', children: [_jsx(Component_ManagerSubHeader, { isInEditMode: this.state.isInEditMode, buttons: [_jsx(Button, { className: `${this.state.isInEditMode ? 'selected' : ''}`, onClick: () => this.setState({ isInEditMode: !this.state.isInEditMode }), children: this.state.isInEditMode ? 'VIEW MODE' : 'EDIT MODE' }, '0'), _jsx(Button, { className: 'selected', onClick: async () => {
                                //todo delete
                                const _item = this.state.item?.item;
                                if (_item?._id)
                                    await ModuleFE_Resource.v1.delete(_item).executeSync();
                            }, children: 'Delete Resource' }, '1')] }), _jsx(ResourceItem_EditorRenderer, { editable: this.state.item, isInEditMode: this.state.isInEditMode })] });
    }
}
